// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"page_categoryList__B_4Qk","categoryItem":"page_categoryItem__k0Ykb","icon":"page_icon__BJpXC"};